<template>
<mainTemplateVue>
    <div>
        <md-toolbar :md-elevation="0" class="md-transparent">
            <h3 class="md-title">Estoque</h3>
            <md-button class="md-primary" to="/estoque/novo">Adicionar novo item</md-button>
        </md-toolbar>

        <md-table v-model="searched" md-fixed-header>
            <md-table-empty-state
                md-label="Sem registros"
                :md-description="`No user found for this '${search}' query. Try a different search term or create a new user.`">
                <md-button class="md-primary md-raised" @click="newUser">Create New User</md-button>
            </md-table-empty-state>

            <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="ID" md-sort-by="estoqueItem_id" md-numeric>{{ item.estoqueItem_id }}</md-table-cell>
                <md-table-cell md-label="Nome" md-sort-by="estoqueItem_nome">{{ item.estoqueItem_nome }}</md-table-cell>
                <md-table-cell md-label="Estoque Min" md-sort-by="estoqueItem_estoqueMinimo" md-numeric>{{ item.estoqueItem_estoqueMinimo }}</md-table-cell>
                <md-table-cell md-label="Quantidade" md-sort-by="estoqueItem_quantidade" md-numeric>{{ item.estoqueItem_quantidade }}</md-table-cell>
                <md-table-cell md-label="Preço Min" md-sort-by="estoqueItem_precoMinimo" md-numeric>{{ item.estoqueItem_precoMinimo }}</md-table-cell>
                <md-table-cell md-label="Preço Total" md-sort-by="estoqueItem_precoMinimo" md-numeric>{{ item.valorTotal }}</md-table-cell>
                <md-table-cell md-label="Un. de Medida" md-sort-by="estoqueItem_precoMinimo" md-numeric>{{ item.unidade_medida.unidadeMedida_nome }}</md-table-cell>
                <md-table-cell>
                  <md-button class="md-primary" :to="`/estoque/editar/${item.estoqueItem_id}`"><md-icon>edit</md-icon></md-button>
                  <md-button class="md-accent" @click="removeItem(item.estoqueItem_id)"><md-icon>clear</md-icon></md-button>
                </md-table-cell>
            </md-table-row>
        </md-table>

        <md-snackbar :md-active.sync="showSnackMessage">{{snackMessage}}</md-snackbar>

        <md-dialog-confirm
        :md-active.sync="removeItemDialog"
        md-title="Deseja realmente remover este item?"
        md-confirm-text="Remover"
        md-cancel-text="Cancelar"
        @md-cancel="onCancelDialogRemoveItem"
        @md-confirm="onConfirmDialogRemoveItem" />
    </div>
</mainTemplateVue>
</template>

<script>
import mainTemplateVue from '../../components/main-template.vue'
import { api } from '../../services/api'

export default {
    name: 'estoque-item-list',
    components: {
        mainTemplateVue
    },
    data: () => ({
      removeItemDialog: false,
      idToBeRemoved: null,
      snackMessage: false,
      showSnackMessage: false,
      search: null,
      searched: [],
      unidades: []
    }),
    methods: {
      newUser () {
        window.alert('Noop')
      },

      async getListItem(){
        let req = await api().get('estoque/item')
        this.searched = req.data.data

        console.log(this.searched)
      },
      
      removeItem(id){
        this.removeItemDialog = true
        this.idToBeRemoved = id
      },

      async onConfirmDialogRemoveItem(){
        api().delete(`/estoque/item/${this.idToBeRemoved}`).then(() =>  {
          this.showSnackMessage = true
          this.snackMessage = "Registro removido com sucesso"
          this.getListItem()
        }).catch(() => {
          this.showSnackMessage = true
          this.snackMessage = "Falha ao remover o item, verifique se há itens vinculados a ele e tente novamente."
        })
      },

      onCancelDialogRemoveItem(){
        this.idToBeRemoved = null
        this.removeItemDialog = false
      }
    },
    created () {
      this.getListItem()
    }
}
</script>

<style>
.md-table-head, .md-table-head.md-numeric {
    text-align: left !important;
}

.md-table-cell {
    text-align: left !important;
}
</style>